import "./SideMenu.css";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SideMenu = ({ items }) => {
  const [itemsState, setItemsState] = useState([]);
  const location = useLocation();

  useEffect(() => {
    if (items) {
      items.forEach((item) => {
        item.selected = item.url === location.pathname;
      });
      setItemsState(items);
    }
  }, [items]);

  return (
    <div className="side-menu">
      <ul>
        {itemsState?.map((item, index) => (
          <li
            key={index}
            className="menu-item"
            style={{
              backgroundColor: item?.selected ? "#223D51" : "#f7f7f7",
            }}
            onClick={() => {
              items.forEach((item) => (item.selected = false));
              const thisItem = items[index];
              thisItem.selected = true;
              setItemsState([...items]);
            }}
          >
            {/* Link invisible que ocupa todo el rectángulo */}
            <Link
              to={item.url}
              className="menu-overlay"
              aria-label={item.texto}
            />

            {/* Contenido visible encima del overlay */}
            <div className="menu-left">
              <span className={`menu-icon ${item?.selected ? "selected" : ""}`}>
                {item.icon}
              </span>
              <span
                className="menu-text"
                style={{ color: item?.selected ? "#FFFFFF" : "#223D51" }}
              >
                {item.texto}
              </span>
            </div>

            {/* Chincheta a la derecha (no navega) */}
            <button
              type="button"
              className="menu-pin"
              onClick={(e) => {
                e.stopPropagation();
                item.onIconClick?.();
              }}
            >
              {item.chincheta}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default SideMenu;
